import { ReactNode } from "react";
import "antd/dist/antd.css";
import Icon from "ui/Icon";
import CloseIcon from "core/icons/cross/cross2.svg";
import { SpacingStyle } from "core/styles/paddingMarginStyle";
import { Container, ModalGlobalStyle } from "./_modalStyle";
import { TEST_ID } from "core/constants/test-id";

export type ModalProps = {
  width?: any;
  closable?: boolean;
  isDisplay?: boolean;
  titleModal?: string;
  atCenterScreen?: boolean;
  closeIcon?: boolean;
  onClose?: React.MouseEventHandler;
  children?: ReactNode;
  rightPosCloseIcon?: string;
  topPosCloseIcon?: string;
  onCancel?: () => void;
  maskClosable?: boolean;
  padding?: number | string;
  open?: boolean;
  centered?: boolean;
} & SpacingStyle;

function Modal(props: ModalProps) {
  const {
    isDisplay,
    closable,
    titleModal,
    width,
    children,
    closeIcon,
    onClose,
    onCancel,
    ...rest
  } = props;

  return (
    <>
      {isDisplay && <ModalGlobalStyle />}
      <Container
        visible={isDisplay}
        title={titleModal}
        width={width}
        footer={null}
        closable={closable}
        onCancel={onCancel}
        {...rest}>
        {children}
        {closeIcon && (
          <Icon
            onClick={onClose || onCancel}
            data-testid={TEST_ID.modal.closeButton}
            className="modal-close-icon"
            src={CloseIcon}
          />
        )}
      </Container>
    </>
  );
}

Modal.defaultProps = {
  width: null,
  closable: false,
  isDisplay: false,
  titleModal: "",
  atCenterScreen: false,
  closeIcon: false,
};

export default Modal;
